<template>
<div class="home">
    <header id="logo">
        <img src="../assets/logo.png" alt="Pixel Mort">
        pixelmort.fr
    </header>

    <p class="separator"></p>

    <div class="test-button-wrapper">
        <router-link to="/test" class="test-button">
            Lancer le test
        </router-link>
    </div>

    <section class="columns">
        <div class="left">
            <h2>À quoi sert ce site&nbsp;?</h2>

            <p>
                À vous aider à vérifier la présence de pixels morts dans votre écran.
            </p>

            <p>
                En cliquant sur "Lancer le test", l'écran sera rempli d'une couleur unique. Un menu vous permet de
                passer à d'autres couleurs. Il est également possible d'utiliser les touches gauche et droite.
            </p>
        </div>

        <div class="right">
            <h2>Les garanties des constructeurs</h2>

            <p>
                Question complexe. Cela dépend de la marque, du modèle, de la taille de l'écran...
            </p>

            <p>
                Pour certains, c'est la diagonale de l'écran qui détermine la garantie. Pour d'autres, c'est le
                nombre total de pixels.
                Pour compliquer les choses, il faut parfois avoir un nombre minimum de pixels défectueux.
            </p>
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'Home',
};
</script>

<style>
body {
    background: url("../assets/background.jpg");
    background-size: cover;
    text-decoration: none;
    margin: 0;
}
</style>

<style scoped lang="less">
@font-face {
    font-family: 'rustregular';
    src: url('../assets/font/rust-webfont.woff2') format('woff2'),
    url('../assets/font/rust-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

#logo {
    justify-content: center;
    align-items: center;
    display: flex;
    color: #F9C718;
    font-size: 6vw;
    font-family: rustregular, sans-serif;
    text-decoration: none;
    margin-bottom: 2%;

    > img {
        max-width: 20%;
    }
}

.separator {
    border-bottom: 2vw dashed #F9C718;
    margin-top: -3%;
    margin-bottom: 30px;
}

.test-button-wrapper {
    padding: 10px;

    .test-button {
        @color: #f9c718;
        box-shadow: 0 0 30px 5px;
        color: @color;
        border: dashed 3px @color;
        padding: 10px 20px;
        text-decoration: none;
        font-size: 2.5vh;
        font-weight: bold;
        margin: 10px;
    }
}

.columns {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    color: white;
    margin: 0 10%;

    > div {
        width: 50%;
        text-align: justify;
        flex-grow: 1;
        margin: 10px 30px;

        > h2 {
            text-align: center;
        }
    }

    @media (max-width: 650px) {
        flex-direction: column;

        > div {
            width: 100%;
            margin: 10px 0;
        }
    }
}
</style>
